import React from "react";
import { OutfitCard } from "../../outfits/viewOutfits/OutfitCard";
import { NoItemCard } from "../../general/misc/NoItemCard";
import { IoCloseSharp } from "react-icons/io5";

export const LookbookAdderCard = ({
	outfit = null,
	onCardClick = () => {},
	cardType = "",
}) => {
	return !outfit ? (
		<NoItemCard />
	) : (
		<div
			className="transition-all duration-75 cursor-pointer relative rounded-sm"
			onClick={() => onCardClick(outfit)}
		>
			<div className="z-10 text-red-600 transition-all flex items-center justify-center duration-50 absolute top-0 w-full bg-red-600 bg-opacity-20 h-full opacity-0 hover:opacity-100 border border-transparent hover:border-red-600">
				<IoCloseSharp size={64} />
			</div>
			<OutfitCard nohover={true} cardType={cardType} outfit={outfit} />
		</div>
	);
};
